import { BoxCenteredElement } from '@thive/canvas';
import { Obstacle } from '@thive/fddm-types';
import { Vector3 } from 'three';

import { RectangleUtils } from '@/modules/floorplanDesign/helpers/RectangleUtils';
import { WALL_MATERIAL_TYPE_TO_TEXTURE_VARIANT } from './visualization3DConstants';
import { radToDeg } from 'three/src/math/MathUtils.js';
import { VectorUtils } from '@/modules/common/utils/VectorUtils';
import { FDDM_TAG } from '@/modules/floorplanDesign/constants';

export const createWall = (obstacle: Obstacle): BoxCenteredElement[] => {
  const { id, name, segments, wallMaterial } = obstacle;
  const textureVariant = WALL_MATERIAL_TYPE_TO_TEXTURE_VARIANT[wallMaterial ?? 'CONCRETE'];
  return segments.map((segment, index) => {
    const rectangle = RectangleUtils.fromSegment(segment);
    const { centerX, centerY, length, width } = rectangle;

    return {
      id: `${id}-wall-${index}`,
      name: `${name}-${index}`,
      type: 'BoxCentered',
      scale: VectorUtils.metersToMm(new Vector3(length, width, segment.height ?? 1)),
      position: VectorUtils.metersToMm(new Vector3(centerX, centerY, 0)),
      rotation: new Vector3(0, 0, radToDeg(rectangle.angle)),
      tags: [FDDM_TAG.MODEL],
      materialModifier: {
        textureVariant,
      },
    };
  });
};
